// extracted by mini-css-extract-plugin
export default {"avatar-large":"Profile_avatar-large__0Kk+C"};